import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Buttons";
import { ComparativeTransportPdf } from "../../components/common/ComparativeTransportPdf";
import PurchaseOrder from "../../components/common/PurchaseOrder";
import { QuoteComparison } from "../../components/common/QuoteComparison";
import { DialogConfirmation } from "../../components/Modal";
import CallServiceTable from "../../components/Tables/CallServiceTable";
import { H3 } from "../../components/Text";
import { useDialog } from "../../contexts/DialogContext";
import { useModal } from "../../contexts/ModalContext";
import { ReportPaymentsModal } from "../../pages/menu/folderList/ReportPaymentsModal";
import { FormAdditionalInformation } from "./FormAdditionalInformation";
import { FormArriboImportacion } from "./FormArriboImportacion";
import { FormArrivalTracking } from "./FormArrivalTracking";
import { FormIncidents } from "./FormIncidents";
import { FormInsuranceApplication } from "./FormInsuranceApplication";
import { FormNacionalizacion } from "./FormNacionalizacion";
import { FormPaymentControl } from "./FormPaymentControl";
import { FormQuotes } from "./FormQuotes";
import { FormTransportContract } from "./FormTransportContract";
import { ImportTrackingModal } from "./ImportTrackingModal";
import { SendProcedure } from "../steps";

const ViewSubProcedure = (props) => {
  const { rolId, procedure, reload } = props;

  const navigate = useNavigate();
  const { openModal, onClose } = useModal();
  const { openDialog, dialogClose } = useDialog();

  function handleFolderStep(procedure) {
    navigate(
      `/rol/${rolId}/menu/folderList/step-procedure/${procedure.procedureId}`,
    );
  }

  function handleSendProcedure(procedure, reloadTable) {
    openModal(
      <SendProcedure
        openModal={openModal}
        procedure={procedure}
        reload={typeof reloadTable === "function" ? reloadTable : () => {}}
        onClose={onClose}
      />,
    );
  }

  function handleQuoteComparison(procedure) {
    openDialog(<QuoteComparison procedureId={procedure.procedureId} />);
  }

  function handlePurchaseOrder(procedure) {
    openDialog(<PurchaseOrder procedureId={procedure.procedureId} />);
  }

  function handleFormQuotes(procedure) {
    openModal(
      <FormQuotes procedure={{ ...procedure, id: procedure.procedureId }} />,
    );
  }

  function handleArrivalTracking(procedure) {
    openModal(
      <FormArrivalTracking
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  function handleAdditionalInformation(procedure) {
    openModal(
      <FormAdditionalInformation
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  function handlePaymentControl(procedure) {
    openModal(
      <FormPaymentControl
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  function handleComparativeTransport(procedure) {
    openDialog(<ComparativeTransportPdf procedureId={procedure.procedureId} />);
  }

  function handleTransportContract(procedure) {
    openModal(
      <FormTransportContract
        procedure={{ ...procedure, id: procedure.procedureId }}
        parentProcedure={props.procedure}
      />,
    );
  }

  function handleIncidents(procedure) {
    openDialog(
      <FormIncidents procedure={{ ...procedure, id: procedure.procedureId }} />,
    );
  }
  function handleSureApplication(procedure, reloadTable) {
    openModal(
      <FormInsuranceApplication
        procedure={{ ...procedure, id: procedure.procedureId }}
        reload={reloadTable || reload}
        handleSendProcedure={handleSendProcedure}
      />,
    );
  }

  function handleArriboImportacion(procedure) {
    openModal(
      <FormArriboImportacion
        procedure={{
          ...procedure,
          id: procedure.procedureId,
          parentProcedureId:
            props.procedure?.id || props.procedure?.procedureId,
        }}
      />,
    );
  }

  function handleNacionalizacion(procedure) {
    openModal(
      <FormNacionalizacion
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  function handleImportTracking(procedure) {
    openDialog(
      <ImportTrackingModal
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  // function handleReportDates() {
  //   openDialog(<ReportDatesModal onClose={dialogClose} />);
  // }

  // function handleReportPayments() {
  //   openDialog(<ReportPaymentsModal onClose={dialogClose} />);
  // }

  // function handleReportRitex() {
  //   openDialog(<ReportRitexModal onClose={dialogClose} />);
  // }

  // function handleReportArrival() {
  //   openDialog(<ReportArrivalModal onClose={dialogClose} />);
  // }

  // function handleReportIncidents() {
  //   openDialog(<ReportIncidentsModal onClose={dialogClose} />);
  // }

  function handleAdd(reload, index) {
    openDialog(
      <DialogConfirmation
        children={
          <H3>¿Estas seguro que quieres crear un nuevo subprocedimiento?</H3>
        }
        onClose={dialogClose}
        method="post"
        url={`/Procedure/${procedure.id}/sub-procedures`}
        texBtn="Crear"
        handleSuccess={reload}
        data={{
          companyId: procedure.companyId,
          procedureTypeId: procedure.procedureTypeId,
          userId: window.localStorage.getItem("id"),
          step: 9,
          datasets: [
            {
              value: `${procedure.codigoDeInterno}-${String.fromCharCode(65 + index)}`,
              procedureId: 0,
              fieldId: 3,
            },
            {
              value: `${procedure.moneda}`,
              procedureId: 0,
              fieldId: 2033,
            },
            {
              value: `${procedure.terminosPago}`,
              procedureId: 0,
              fieldId: 2015,
            },
          ],
        }}
      />,
    );
  }
  console.log(procedure, "procedure");

  return (
    <div className="">
      <div className="flex">
        <H3 className="text-start">Lista de Parciales </H3>
      </div>
      <CallServiceTable
        component={({ reload, data }) => {
          return (
            <>
              <Button
                onClick={() => handleAdd(reload, data?.length || 0)}
                className="px-3 py-1 gap-2"
              >
                <i className="fas fa-plus"></i>
                {"Adicionar"}
              </Button>
            </>
          );
        }}
        // onClick={handleViewSubProcedure}
        filters={
          [
            //   {
            //     name: "procedureType",
            //     url: "/procedureType",
            //     default: "Todos los tramites",
            //     valueOption: "id",
            //     labelOption: "name",
            //   },
            //   {
            //     name: "companyId",
            //     url: "/company/getallcompanies",
            //     default: "Todas las compañías",
            //     valueOption: "id",
            //     labelOption: "razonSocial",
            //   },
            //   {
            //     // url: '/company/getallcompanies',
            //     // name: 'companyId',
            //     // valueOption: 'id',
            //     // labelOption: 'razonSocial',
            //     type: "rangeDate",
            //   },
          ]
        }
        urlApi={`/Procedure/${procedure.id}/sub-procedures`}
        addUrl={`fieldnames=codigoDeInterno`}
        // addFilters={[
        //   {
        //     name: "procedureNumber",
        //     label: "Tramite",
        //     filter: true,
        //   },
        //   {
        //     name: "internCode",
        //     label: "Nro. interno",
        //     filter: true,
        //   },
        //   {
        //     name: "dimNumber",
        //     label: "Nro. DIM/DEX",
        //     filter: true,
        //   },
        // ]}
        header={[
          { label: "NÚMERO DE IMPORTACIÓN", name: "codigoDeInterno" },
          {
            name: "Action",
            label: "Acciones",
            type: "action",
            sticky: true,
            actions: [
              {
                label: "Lista de Pasos",
                icon: "fas fa-shoe-prints",
                action: handleFolderStep,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Seguimiento de Importacion",
                icon: "fas fa-book",
                Name: "logbook",
                action: handleFormQuotes,
                color: "text-[#3b82f6]",
                bgColor: "bg-blue-50",
                borderColor: "border-blue-200",
              },
              // {
              //   label: "Comparación de cotizaciones",
              //   icon: "fa-solid fa-chart-column",
              //   Name: "quote-comparison",
              //   action: handleQuoteComparison,
              //   color: "text-[#3b82f6]",
              //   bgColor: "bg-blue-50",
              //   borderColor: "border-blue-200",
              // },
              // {
              //   label: "Orden de compra",
              //   icon: "fa-solid fa-cart-shopping",
              //   Name: "purchase-order",
              //   action: handlePurchaseOrder,
              //   color: "text-[#10b981]",
              //   bgColor: "bg-emerald-50",
              //   borderColor: "border-emerald-200",
              // },
              {
                label: "Aplicación del seguro",
                icon: "fa-solid fa-shield-alt",
                Name: "documentation",
                action: handleSureApplication,
                color: "text-[#10b981]",
                bgColor: "bg-emerald-50",
                borderColor: "border-emerald-200",
              },
              {
                label: "Control de pagos",
                icon: "fas fa-dollar-sign",
                Name: "payment-control",
                action: handlePaymentControl,
                color: "text-[#8b5cf6]",
                bgColor: "bg-violet-50",
                borderColor: "border-violet-200",
              },
              {
                label: "Fechas de transito y arribo",
                icon: "fa-solid fa-calendar-days",
                Name: "additional-information",
                action: handleAdditionalInformation,
                color: "text-[#8b5cf6]",
                bgColor: "bg-violet-50",
                borderColor: "border-violet-200",
              },
              {
                label: "Cuadro comparativo de transporte",
                icon: "fa-solid fa-truck-moving",
                Name: "transport-comparison",
                action: handleComparativeTransport,
                color: "text-[#f59e0b]",
                bgColor: "bg-amber-50",
                borderColor: "border-amber-200",
              },
              {
                label: "Formulario de contrato de transporte",
                icon: "fa-solid fa-file-contract",
                Name: "transport-contract",
                action: handleTransportContract,
                color: "text-[#f59e0b]",
                bgColor: "bg-amber-50",
                borderColor: "border-amber-200",
              },
              {
                label: "Bitrix24",
                icon: "fas fa-circle-info",
                Name: "arrival-tracking",
                action: handleArrivalTracking,
                color: "text-[#10b981]",
                bgColor: "bg-emerald-50",
                borderColor: "border-amber-200",
              },
              {
                label: "Transito",
                icon: "fa-solid fa-ship",
                Name: "arribo-importacion",
                action: handleArriboImportacion,
                color: "text-[#f59e0b]",
                bgColor: "bg-amber-50",
                borderColor: "border-amber-200",
              },
              {
                label: "Seguimiento de Incidencias",
                icon: "fa-solid fa-triangle-exclamation",
                Name: "incidents-tracking",
                action: handleIncidents,
                color: "text-[#ef4444]",
                bgColor: "bg-red-50",
                borderColor: "border-red-200",
              },
            ],
          },
        ]}
      />
    </div>
  );
};

export default ViewSubProcedure;
